import { useEffect } from 'react'
import { Route, Switch } from 'react-router-dom'

import { useDisableSalesforceChat } from 'core/ui/hooks/useDisableSalesforceChat'
import { PageNotFound } from 'core/ui/router/PageNotFound'

import BidsPanel from '../bids/ui/BidsPanel'
import ShipperGuideLayout from '../core/ui/layout/shipperguide-layout/ShipperGuideLayout'
import { analytics } from '../core/utils/analytics'
import RfpPage from '../rfp/ui/RfpPage'
import { ShipmentDetails } from '../shipments/ui/ShipmentDetails'
import { ShipperLoadsPage } from '../shipments/ui/ShipperLoadsPage'
import SpotQuotePage from '../spot-quotes/ui/SpotQuotePage'
import { TenderPage } from '../tender/ui/TenderPage'

const BASE_PATH = '/all-in-one'

export default function ShipperGuide() {
  useDisableSalesforceChat()

  useEffect(() => {
    analytics.init()
  }, [])

  return (
    <ShipperGuideLayout>
      <Switch>
        <Route path={`${BASE_PATH}/shipments`} exact>
          <ShipperLoadsPage />
        </Route>
        <Route path={`${BASE_PATH}/shipment/:shipmentUUID/:section?`}>
          <ShipmentDetails />
        </Route>
        <Route path={`${BASE_PATH}/bids-list`} exact>
          <BidsPanel />
        </Route>
        <Route path={`${BASE_PATH}/bids/spot-quote`} component={SpotQuotePage} />
        <Route path={`${BASE_PATH}/tender/:id`} component={TenderPage} />
        <Route path={`${BASE_PATH}/rfp`} component={RfpPage} />
        <Route path="*">
          <PageNotFound />
        </Route>
      </Switch>
    </ShipperGuideLayout>
  )
}
